import React, { useEffect, useState } from "react";
import "../styles.css";
import "bootstrap/dist/css/bootstrap.css";
import { postPersonFileUpload } from "api/AccountsApi";
import { toast } from "react-toastify";
import { getPermissions } from 'api/UsersApi'
import SupportLink from "../Common/SupportLink";
import 'styles.css'
var FormData = require("form-data");

function CreateAccount(props) {
  const [fileName, setFilename] = useState();
  const [fileSize, setFileSize] = useState();
  const [fileCondition, setFileCondition] = useState(false);
  const [orgCondition, setOrgCondition] = useState(false);
  const [logID, setLogUID] = useState("");
  const [subcscribption, setSubscribtion] = useState("Subscribes");
  const [check, setCheck] = useState(false);
  const [prospectCheck, setProspectCheck] = useState(false);
  const [loading, setgLoading] = useState(false);
  const [fileUploadPermission, setFileUploadPermission] = useState(true);
  const [uploadButtonPermission, setUploadButtonPermission] = useState(true);
  const [permissionMessage, setPermissionMessage] = useState(null);
  const [showPermissionMessage, setShowPermissionMessage] = useState(true);
  useEffect(() => {
    getPermissions().then(res => {
      setUploadButtonPermission(!res["UploadFiles"].allowed)
      setPermissionMessage(res["UploadFiles"].message)
    })
  }, []);
  const SubscribedOrUnSubscribed = (e) => {
    setSubscribtion(e.target.value);
  };

  const checkedHandler = (e) => {
    if (check === false) {
      setCheck(true);
    } else {
      setCheck(false);
    }
  };

  const prospectCheckedHandler = (e) => {
    if (check === false) {
      setProspectCheck(true);
    } else {
      setProspectCheck(false);
    }
  };

  const ContinueTag = () => {
    if (fileCondition) {
      var arr = [logID, subcscribption, check, prospectCheck];

      sessionStorage.setItem("KWlogId", arr);

      props.history.push("/admin/contact/tagcontact");
    } else {
      toast.info("Please Upload a File");
    }
  };
  const OrgCondition = () => {
    setOrgCondition(true);
  };
  const uploadFile = (event) => {
    setgLoading(true);
    const data = new FormData();
    const files = event.target.files[0];
    data.append("file", files);
    if (Math.floor(files.size / 1000000) > 200) {
      setFileUploadPermission(false);
    }
    postPersonFileUpload(data)
      .then(function (data) {
        setLogUID(data.logId);
        setFilename(files.name);
        setFileSize(Math.floor(files.size / 1000000));
        setFileCondition(true);
        setgLoading(false);
      })
      .catch(function (error) {

      });
  };

  const messageBar = (permissionMessage) => {
    if (permissionMessage) {
      return (
        showPermissionMessage && <div style={{ width: '100%', height: '50px', backgroundColor: '#FEF6E6', color: 'rgb(237 146 23)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "DM Sans", fontSize: '16px', padding: '35px' }}>
          <div dangerouslySetInnerHTML={{ __html: permissionMessage }} className='messagebar__text'></div>
          <span onClick={() => {
            setShowPermissionMessage(false)
          }} style={{ marginLeft: '10px', fontSize: '15px', cursor: 'pointer' }}> <i className="fa fa-times"></i> </span>
        </div>
      )
    }
  }
  return (
    <div>
      {messageBar(permissionMessage)}
      <SupportLink link='https://kapitalwise.com/user-guide/contacts/' />
      <div className="page_heading">
        <h2>Import Contacts</h2>
        <p className="glo-desc"> Effortlessly amplify your contact database by uploading multiple contacts at once. </p>
      </div>
      <div className="importAccount">
        <form>
          <div className="kwUpload">
            <input
              type="file"
              accept=".csv"
              id="uploadFile"
              onChange={uploadFile}
              disabled={uploadButtonPermission}

            // disabled={true}
            />
            <label for="uploadFile" style={uploadButtonPermission ? { opacity: 0.5 } : { opacity: 1 }}>
              <span class="icon-dashboard-icons-14"></span>
              <p>
                Drag and drop contact here <span>or</span>
              </p>
              <span className="uploadBtn md_btn2 primary">
                {!loading ? "Upload Files" : "Loading..."}
              </span>
            </label>
          </div>
          <ul className="file_conditions">
            <li>Upload file should be in comma-separated values (CSV) format.</li>
            <li>First row is considered a header row.</li>
          </ul>
          {fileCondition ? (
            <div>
              <div className="uploadedFiles">
                <ul>
                  <li>
                    <p>
                      {fileName}
                      <span>{fileSize}Mb</span>
                    </p>
                    <span class="succesIcon icon-dashboard-icons-10"></span>
                  </li>
                </ul>
              </div>

              <div className="organizeBtn">
                {!fileUploadPermission && <div className="uploadedFiles">
                  <p>
                    Your uploaded file size is more than the maximum allowed limit - 200MB. Please divide the file into smaller chunks and try to upload again
                  </p>
                </div>}
                <a
                  to
                  onClick={() => {
                    if (fileUploadPermission) {
                      OrgCondition()
                    }
                  }}
                  className="uploadBtn md_btn2 primary"
                  style={fileUploadPermission ? { opacity: 1 } : { opacity: 0.5 }}
                >
                  Continue to Organize
                </a>
              </div>
            </div>
          ) : (
            ""
          )}
          {orgCondition ? (
            <div className="organizeContacts">
              <h3 className="font1">Organize Your Contacts</h3>
              <div className="inputOuter">
                <label className="medium">Select a Status</label>
                <select
                  onChange={SubscribedOrUnSubscribed}
                  id="selectSubscribtion"
                  className="selectpicker kwDesign2 w486"
                >
                  <option>Subscribed</option>
                  <option>Unsubscribed</option>
                </select>
                <p className="infoText">
                  when you choose the "<a>subscribed </a>" status for your
                  contacts, it indicates that you have gained permission to
                  market to them. learn more about the{" "}
                  <a>importance of permission</a>.
                </p>
              </div>
              {/* Prospect */}
              <div className="inputOuter">
                <div className="kwCheckboxw20">
                  <input
                    onChange={prospectCheckedHandler}
                    type="checkbox"
                    id="checkbox2"
                  />
                  <label
                    id="checkID2"
                    for="checkbox2"
                    className="kwCheckboxText"
                  >
                    Prospect
                  </label>
                </div>
                <p className="infoText">
                  Check this box if the contacts in your file are prospects. Ignore, if the contacts are customers.
                </p>
              </div>
              {/* Update Existing contact */}
              <div className="inputOuter">
                <div className="kwCheckboxw20">
                  <input
                    onChange={checkedHandler}
                    type="checkbox"
                    id="checkbox1"
                  />
                  <label
                    id="checkID"
                    for="checkbox1"
                    className="kwCheckboxText"
                  >
                    Update any existing contacts
                  </label>
                </div>
                <p className="infoText">
                  If any imported contacts are already in your audience, we will
                  automatically replace their information with the data from
                  your import. this option may make the import process take
                  longer.
                </p>
              </div>
              <a
                onClick={ContinueTag}
                to="/admin/contact/tagcontact"
                className="md_btn2 primary w200"
              >
                Continue to Tag
              </a>
            </div>
          ) : (
            ""
          )}
        </form>
      </div>
    </div>
  );
}

export default CreateAccount;
